// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"TooltipTitle_modal-scroll__qNWTd","tooltipTitle":"TooltipTitle_tooltipTitle__PPgBi"};